import React from 'react';

import './styles.scss';
import { APP_TEXTS } from '@texts';

export default props => (
  <React.Fragment>
    {props.showDialog && (
      <div className="dialog">
        <div className="dialog__content">
          <h4>{props.message}</h4>

          <div className="control-group">
            {props.onYes && (
							<button className="btn btn-yes" onClick={props.onYes}>
								{APP_TEXTS.BUTTONS_YES.Content}
							</button>
            )}
            {props.onNo && (
							<button className="btn btn-no" onClick={props.onNo}>
								{APP_TEXTS.BUTTONS_NO.Content}
							</button>
            )}
            {props.onCancel && (
							<button className="btn btn-cancel" onClick={props.onCancel}>
								{APP_TEXTS.BUTTONS_CANCEL.Content}
							</button>
            )}
          </div>
        </div>
      </div>
    )}
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/Prompt/index.js